const cache = /* @__PURE__ */ new Map();
function whitelistHtml(text, {
  allowParagraphs = false
} = {}) {
  const whitelisted = cache.get(text);
  if (whitelisted) {
    return whitelisted;
  }
  if (text.length === 0 || text.trim().length === 0) {
    return text;
  }
  const safeText = text.replace(/&amp;/gim, "&").replace(
    /[\u00A0-\u9999<>&]/gim,
    (i) => "&#" + i.charCodeAt(0) + ";"
  );
  if (safeText.indexOf("&#60;") === -1) {
    return safeText;
  }
  const html = safeText.replace(
    allowParagraphs ? /&#60;(\/?(sub|sup|em|i|strong|b|u|br|br\/|br \/|p|ol|ul|li))\/?&#62;/gi : /&#60;(\/?(sub|sup|em|i|strong|b|u|br|br\/|br \/))\/?&#62;/gi,
    "<$1>"
  ).replace(/<br>/g, "<br />");
  const parser = new DOMParser();
  const document = parser.parseFromString(`<span>${html}</span>`, "text/xml");
  const errorCount = document.getElementsByTagName("parsererror").length;
  if (!errorCount) {
    cache.set(text, html);
    return html;
  }
  cache.set(text, safeText);
  return safeText;
}

export { whitelistHtml };
//# sourceMappingURL=dom.whitelist-html.js.map
